import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAgency'

// Strip null/undefined values so serialize() never sends "null" strings.
const clean = params =>
	Object.fromEntries(Object.entries(params).filter(([, v]) => v !== null && v !== undefined && v !== 'null'))

export const adminPressKitList = (params = {}) => Http.get(`/admin/press-kits${serialize(clean(params))}`)
export const adminPressKitCreate = (params = {}) => Http.post('/admin/press-kits', params)
export const adminPressKitById = id => Http.get(`/admin/press-kits/${id}`)
export const adminPressKitPreviewUrl = id => Http.get(`/admin/press-kits/${id}/preview-url`)
export const adminPressKitUpdateStatus = (id, status) => Http.patch(`/admin/press-kits/${id}/status`, { status })
export const adminPressKitUpdateTheme = (id, theme) => Http.patch(`/admin/press-kits/${id}/theme`, { theme })
export const adminPressKitSendInsightsEmail = id => Http.post(`/admin/press-kits/${id}/send-insights-email`)
export const adminPressKitDestroy = id => Http.delete(`/admin/press-kits/${id}`)
